import { StateCreator } from "zustand";

interface IRedirectState {
  redirectPath: string | null;
}

interface IRedirectActions {
  setRedirectPath: (path: string | null) => void;
}

export interface IRedirectStore extends IRedirectState, IRedirectActions {}

export const createRedirectSlice: StateCreator<IRedirectStore> = (set) => ({
  redirectPath: null,
  setRedirectPath: (path: string | null) => {
    set(() => ({
      redirectPath: path,
    }));
  },
});
